














































































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import UiList from '@superUI/List/List'
import states from '@assets/states.json'
import dma from '@assets/dma.json'

settings =
  name: "UniversityList"
  components: { SuperContainerView, UiList }
  resources:
    universities:
      resourceName: "universities"
      slug: "universities"
      infinityScroll: true

  vue:
    data: ->
      searchValue: ''
      searchTimeout: null

      activeFilter: false
      selectedFilters: []
      selected_multi_filters: {}
      selected_filters: {}

      state_options: states
      dma_options: dma

    methods:
      hiToggleFilterDisplay: -> @activeFilter = !@activeFilter

      hiFilterChange: ->
        @fetchInfinity(null, 'universities', @combinedFilters(), { page: 1 })

      combinedFilters: ->
        q = @searchValue

        filters = {}
        for k, v of @selected_filters
          filters[k] = v if v.length

        multi_filters = {}
        for k, v of @selected_multi_filters
          multi_filters[k] = v if v.length

        enrollment_num = @enrollment_value

        return { q, filters, multi_filters }

      debounceSearch: (value) ->
        ctx = this
        clearTimeout(@searchTimeout)
        @searchTimeout = setTimeout(() ->
          ctx.hiFilterChange()
        , 500)
      mounted: ->
        console.log "\n\n\n\n----- #{@universities?.length}"
      updated: ->
        console.log "\n\n\n\n----- #{@universities?.length}"

    watch:
      searchValue: (value) ->
        @debounceSearch(value)

      selected_filters:
        handler: (value) ->
          @debounceSearch(value)
        deep: true

export default VueOptions.vue settings
